/* eslint-disable import/no-unused-modules */
export { default } from "./ControlledSellerInquiry";
